<template>
  <header class="relative pt-6 sm:pt-8">
    <div id="logo" class="w-full">
      <h1>The Collective</h1>
      <img
        src="@/assets/svg/logo.svg"
        alt="The Collective"
        class="mx-4 md:mx-8"
      />
    </div>
  </header>
</template>

<script>
export default {}
</script>

<style lang="scss" scoped>
#logo > img {
  -webkit-filter: invert(1);
  filter: invert(1);
}

h1 {
  display: none;
}
</style>
